<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow class="no-gutters">
                <CCol sm="9">
                    <span class="font-weight-bold" style="color:rgba(0, 0, 0, 1);font-size:18px">
                        Billing
                    </span>
                </CCol>
                <CCol sm="1 pt-2 text-right pr-2">
                    Status
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchStatus" class="form-control" v-model="status" placeholder="Status"></model-select>
                </CCol>
            </CRow>
            <hr style="border: 1px solid rgba(224, 224, 224, 1)"/>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="2">
                    <CButton v-if="datas.length != 0" @click="exportXLS()" color="success" variant="outline">Export Excel</CButton>
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" @view="viewData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="viewModal"
            :closeOnBackdrop="false"
        >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Hasil Pembayaran Billing</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mb-3">
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                    <CRow>
                                        <CCol sm="5">
                                            <span class="">Nama Perusahaan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewNamaPerusahaan}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Periode Tagihan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewPeriode}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Tipe</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewSatuan}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Harga</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewHarga}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah Pegawai</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{separators(viewJumlahPegawai)}} Pegawai</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah yang ditagih</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewTotalTagihan}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah yang dibayarkan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewTotalBayar}}</span>
                                        </CCol>
                                    </CRow>
                                    <!-- <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Jumlah bulan yang dibayarkan</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewJumlahBulan}} Bulan</span>
                                        </CCol>
                                    </CRow> -->
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Status</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewStatus}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Bukti Bayar</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <img :src="downloadIcon" v-if="viewTipePdf != 'Y'" @click="direct(viewBukti)" width="20px" height="20px" style="cursor:pointer"/>
                                            <img :src="downloadIcon" v-if="viewTipePdf == 'Y'" @click="showPdfBukti(viewBukti)" width="20px" height="20px" style="cursor:pointer"/>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="viewStatus == 'Lunas'" class="mt-1">
                                        <CCol sm="5">
                                            <span class="">Disetujui Oleh</span>
                                        </CCol>
                                        <CCol sm="1 text-right">
                                            :
                                        </CCol>
                                        <CCol sm="6">
                                            <span class="font-weight-bold">{{viewNamaApprove}} Pada {{viewTanggalApprove}}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-1">
                                        <CCol sm="5">
                                            Keterangan
                                        </CCol>
                                        <CCol sm="1">
                                        </CCol>
                                        <CCol sm="6">
                                            <ul class="StepProgress">
                                                <li class="StepProgress-item" v-for="(item, index) in viewKeterangan" :key="'track'+index" :class="[item.status != 'Approved' ? 'is-done' : '']">
                                                    <div>
                                                        <span class="text-primary font-weight-bold">{{item.status}}</span>
                                                            by {{item.namaPegawai}} at {{item.tanggal}}
                                                    </div>
                                                    <div>{{item.keterangan}}</div>
                                                </li>
                                            </ul>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                <CCol sm="2 text-right">
                                    <CButton
                                    color="danger"
                                    variant="outline"
                                    @click="showPdf(viewUnix)"
                                    >
                                    Invoice
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow class="mb-3 mt-2">
                        <CCol sm="12">
                            <CButton @click="closeModal()" type="button" style="float:right" class="btn btn-cancel mr-2">Kembali</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="mt-4 mb-2 area-input">
            <CCol sm="10">
                <h3 class="font-weight-bold">Pembayaran Billing</h3>
            </CCol>
            <CCol sm="2 text-right">
                <CButton
                  color="danger"
                  variant="outline"
                  @click="showPdf(unix)"
                >
                  Invoice
                </CButton>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="2">
                        <span class="">Nama Perusahaan</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{dataNamaPerusahaan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Periode Tagihan</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{dataPeriode}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Tipe</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{dataSatuan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Harga</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{dataHarga}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Jumlah Pegawai</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{separators(dataJumlahPegawai)}} Pegawai</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Jumlah yang ditagih</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{dataTotalTagihan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Status</span>
                    </CCol>
                    <CCol sm="1 text-right">
                        :
                    </CCol>
                    <CCol sm="3">
                        <span class="font-weight-bold">{{dataStatus}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="2">
                        <span class="">Keterangan</span>
                    </CCol>
                    <CCol sm="1 text-right">
                    </CCol>
                    <CCol sm="3">
                        <ul class="StepProgress">
                            <li class="StepProgress-item" v-for="(item, index) in dataKeterangan" :key="'track'+index" :class="[item.status != 'Approved' ? 'is-done' : '']">
                                <div>
                                    <span class="text-primary font-weight-bold">{{item.status}}</span>
                                        by {{item.namaPegawai}} at {{item.tanggal}}
                                </div>
                                <div>{{item.keterangan}}</div>
                            </li>
                        </ul>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Total yang dibayarkan</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.totalBayar.$model"
                            @input="rupiahModeUangSaku('input')"
                            :class="{ 'is-invalid':$v.totalBayar.$error, 'is-valid': !$v.totalBayar.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Total Bayar"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Keterangan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.keterangan.$model"
                            :class="{ 'is-invalid':$v.keterangan.$error, 'is-valid': !$v.keterangan.$invalid }"
                            placeholder="Keterangan" 
                            type="text"
                        />
                    </CCol>
                    <!-- <CCol sm="6">
                        <label>Jumlah Bulan yang dibayarkan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.jumlahBulan.$model"
                            :class="{ 'is-invalid':$v.jumlahBulan.$error, 'is-valid': !$v.jumlahBulan.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Bulan" 
                            type="text"
                        />
                    </CCol> -->
                </CRow>
                <CRow>
                    <CCol sm="3">
                        <label>Upload Bukti Bayar</label>
                        <model-select 
                            :options="dataFile" 
                            class="form-control" 
                            v-model.trim="$v.selectedFile.$model" 
                            :class="{ 'is-invalid select-invalid':$v.selectedFile.$error, 'is-valid select-valid': !$v.selectedFile.$invalid }"
                            placeholder="Pilih File">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow class="mt-3" v-if="selectedFile.value == '1'">
                    <CCol sm="6">
                        <label>Foto(.jpg. .png, .bmp, .jpeg) *maks. size 2MB</label>
                        <div v-if="urlImage == '' || urlImage == 'null'">
                            <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp, .jpeg" />
                            <div class="cards-image" :class="{ 'is-invalid cards-image-invalid':$v.urlImage.$error, 'is-valid cards-image': !$v.urlImage.$invalid }">+</div>
                        </div>
                        <div v-else>
                            <img :src="urlImage" width="56" height="56" />
                            <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                        </div>
                    </CCol>
                </CRow>
                <CRow class="mt-3" v-if="selectedFile.value == '2'">
                    <CCol sm="6">
                        <label>File Pdf *maks. size 2MB</label>
                        <div>
                            <CButton v-if="file == ''" type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih Dokumen</CButton>
                            <input type="file" accept=".pdf, .PDF" @change="loadFile()" style="display:none"  id="inputFile" class="hide" />
                        </div>
                        <!--  -->
                        <p v-if="file != ''" class="font-weight-bold"><span class="mr-3">{{fileName}}</span><CButton class="mr-2" @click="removeFile()" color="danger">Hapus</CButton></p>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit mt-3">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Bayar</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../component/tableBillingPerusahaan'
import { DataApi, DataApiUpload } from "../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
const xlsx = require('json-as-xlsx')
export default {
    components: {
        ModelSelect,
        Tables
    },
    mixins: [validationMixin],
    validations: {
        selectedFile: {
            text: {
                required
            },
            value: {
                required
            }
        },
        urlImage: {
            required
        },
        // jumlahBulan: {
        //     required
        // },
        totalBayar: {
            required
        },
        keterangan: {
            required
        }
    },
    data() {
        return {
            success: true,
            // datas
            refreshIcon: require('../assets/menu/icon_refresh.svg'),
            moreIcon: require('../assets/menu/icon_more.svg'),
            backIcon: require('../assets/menu/icon_goback.svg'),
            closeIcon: require('../assets/menu/icon_close.svg'),
            downloadIcon: require('../assets/menu/icon_download_excel.svg'),
            dataTh: ['Periode Tagihan', 'Tipe', 'User', 'Harga', 'Total Tagihan', 'Status', 'Bukti', 'Action'],
            dataTd: ['periode', 'tipeBilling', 'jumlah', 'price', 'totalHarga', 'status', 'buktiBayar', 'action'],
            styleTable: ['175px', '75px', '75px', '125px', '150px', '100px', '75px', '100px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            dataNamaPerusahaan: '',
            dataPeriode: '',
            dataSatuan: '',
            dataHarga: 0,
            dataJumlahPegawai: '',
            dataTotalTagihan: 0,
            dataStatus: '',
            dataKeterangan: [],

            totalBayar: '',
            // jumlahBulan: '',
            keterangan: '',
            unix: '',

            urlImage: '',
            urlPath: '',
            showImage: '',
            file: '',
            fileName: '',
            fileSize: '',
            urlFile: '',

            lvl: '',
            organisasi: '',
            dataFile: [],
            selectedFile: {
                text: '',
                value: ''
            },
            

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter

            // error
            errorMessage: '',

            viewModal: false,
            viewNamaPerusahaan: '',
            viewPeriode: '',
            viewSatuan: '',
            viewHarga: 0,
            viewJumlahPegawai: '',
            viewTotalTagihan: 0,
            viewStatus: '',
            viewBukti: '',
            viewTipePdf: '',
            // viewJumlahBulan: '',
            viewKeterangan: [],
            viewTotalBayar: '',
            viewNamaApprove: '',
            viewTanggalApprove: '',
            viewUnix: '',

            dataSearchStatus: [],
            status: {
                value: '',
                text: ''
            }
        }
    },
    watch: {
        page() {
            this.getData()
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        status() {
            this.getData()
        },
        selectedFile() {
            if(this.selectedFile.value == '1') {
                this.clearFile()
            } else if(this.selectedFile.value == '2') {
                this.removeImage()
            }
        }
    },
    computed: {
    },
    methods: {
        separators(totals) {
            let val = totals.toString()
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return rupiah
        },
        getDataStatus() {
            this.dataSearchStatus = [
                { value: '', text: 'Semua' },
                { value: 'W', text:'Belum Lunas' },
                { value: 'A', text:'Lunas' },
                { value: 'B', text:'Menunggu' }
            ]
        },
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            this.$store.state.loadingScreen = true
            let payload = {
                limit: this.size,
                pageIn: this.page,
                status: this.status.value
            }
            DataApi.post("billing/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.errorMessage = response.message
                }
                this.$store.state.loadingScreen = false
            })
        },
        reload() {
            this.page = 1
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.dataNamaPerusahaan = ''
                this.dataPeriode = ''
                this.dataSatuan = ''
                this.dataHarga = 0
                this.dataJumlahPegawai = ''
                this.dataTotalTagihan = 0
                this.dataStatus = ''
                this.totalBayar = ''
                this.dataKeterangan = ''
                // this.jumlahBulan = ''
                this.keterangan = ''
                this.unix = ''
                this.urlImage = ''
                this.urlPath = ''
                this.showImage = '',
                this.file = '',
                this.fileName = '',
                this.fileSize = '',
                this.urlFile = '',
                this.$v.$reset()
            }
        },
        goSave() {
            let totalBayar = ''
            let clear = ''
            if(this.totalBayar[0] == 'R') {
                clear = this.totalBayar.replace("Rp. ", '')
                var i
                for(i=0;i<clear.length;i++) {
                    if(clear[i] == '.') {
                        //
                    } else {
                        totalBayar += clear[i]
                    }
                }
            } else {
                totalBayar = this.totalBayar
            }
            // let jumlahBulan = this.jumlahBulan
            let keterangan = this.keterangan
            let unix = this.unix

            let buktiBayar = ''
            if(this.selectedFile.value == '1') {
                buktiBayar = this.urlPath
            } else {
                buktiBayar = this.urlFile
            }

            let payload = {
                buktiBayar: buktiBayar,
                jumlahBulan: '1',
                keterangan: keterangan,
                totalBayar: totalBayar,
                unix: unix
            }
            DataApi.post("billing/bayar", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.dataNamaPerusahaan = generate.namaPerusahaan
            this.dataPeriode = generate.periode
            if(generate.tipeBilling == 'S') {
                this.dataSatuan = 'Satuan'
                this.dataHarga = generate.hargaSatuan
                this.rupiahModeUangSaku('harga')
                this.dataJumlahPegawai = generate.jumlahPegawai
            } else if(generate.tipeBilling == 'P') {
                this.dataSatuan = 'Paket'
                this.dataJumlahPegawai = generate.maxPegawai
                this.dataHarga = generate.totalHarga
                this.rupiahModeUangSaku('harga')
            }
            if(generate.status == 'W') {
                this.dataStatus = 'Belum Lunas'
            } else if(generate.status == 'A') {
                this.dataStatus = 'Lunas'
            } else if(generate.status == 'B') {
                this.dataStatus = 'Menunggu Approval'
            }
            this.dataKeterangan = generate.history
            this.dataTotalTagihan = generate.totalHarga
            this.unix = generate.unix
            this.rupiahModeUangSaku('total')
            this.moving()
        },
        viewData(value) {
            let generate = this.datas[value]
            this.viewNamaPerusahaan = generate.namaPerusahaan
            this.viewPeriode = generate.periode

            if(generate.tipeBilling == 'S') {
                this.viewSatuan = 'Satuan'
                this.viewHarga = generate.hargaSatuan
                this.rupiahModeUangSakuView('harga')
                this.viewJumlahPegawai = generate.jumlahPegawai
            } else if(generate.tipeBilling == 'P') {
                this.viewSatuan = 'Paket'
                this.viewJumlahPegawai = generate.maxPegawai
                this.viewHarga = generate.totalHarga
                this.rupiahModeUangSakuView('harga')
            }
            this.viewUnix = generate.unix

            if(generate.status == 'W') {
                this.viewStatus = 'Belum Lunas'
            } else if(generate.status == 'A') {
                this.viewStatus = 'Lunas'
            } else if(generate.status == 'B') {
                this.viewStatus = 'Menunggu Approval'
            }

            this.viewTotalTagihan = generate.totalHarga

            this.viewBukti = generate.buktiBayar
            this.viewTipePdf = generate.tipePdf
            this.viewTotalBayar = generate.totalBayar
            this.viewKeterangan = generate.history
            this.viewNamaApprove = generate.namaApprover
            this.viewTanggalApprove = generate.tanggalApproved
            this.rupiahModeUangSakuView('bayar')
            this.rupiahModeUangSakuView('total')
            this.viewModal = true
        },
        closeModal() {
            this.viewNamaPerusahaan = ''
            this.viewPeriode = ''
            this.viewSatuan = ''
            this.viewHarga = 0
            this.viewJumlahPegawai = ''
            this.viewTotalTagihan = 0
            this.viewStatus = ''
            this.viewBukti = ''
            this.viewTipePdf = ''
            this.viewUnix = ''
            // this.viewJumlahBulan = ''
            this.viewTotalBayar = ''
            this.viewNamaApprove = ''
            this.viewTanggalApprove = ''
            this.viewModal = false
        },
        direct(link) {
            window.open(link)
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.selectedFile.value == '1') {
                    if(this.file == '') {
                        this.saveImage()
                        this.loading = true
                    }
                } else if(this.selectedFile.value == '2') {
                    if(this.$v.urlImage.$invalid && this.file != '') {
                        this.prosessUpload()
                        this.loading = true
                    }
                }
            } else {
                if(this.selectedFile.value == '1') {
                    this.saveImage()
                } else if(this.selectedFile.value == '2' && this.file != '') {
                    this.prosessUpload()
                }
                this.loading = true
            }
        },
        rupiahModeUangSaku(param) {
            let angka = ''
            if(param == 'input') {
                angka = this.totalBayar
            } else if(param == 'harga') {
                angka = this.dataHarga
            } else if(param == 'total') {
                angka = this.dataTotalTagihan
            }
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(param == 'input') {
                this.totalBayar = hasil
            } else if(param == 'harga') {
                this.dataHarga = hasil
            } else if(param == 'total') {
                this.dataTotalTagihan = hasil
            }
        },
        rupiahModeUangSakuView(param) {
            let angka = ''
            if(param == 'bayar') {
                angka = this.viewTotalBayar
            } else if(param == 'harga') {
                angka = this.viewHarga
            } else if(param == 'total') {
                angka = this.viewTotalTagihan
            }
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            if(param == 'bayar') {
                this.viewTotalBayar = hasil
            } else if(param == 'harga') {
                this.viewHarga = hasil
            } else if(param == 'total') {
                this.viewTotalTagihan = hasil
            }
        },
        getDataToken() {
            this.$store.state.loadingScreen = true
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                }
                this.$store.state.loadingScreen = false
                this.getData()
            })
        },

        showPdf(val) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: val
            }
            DataApi.post("/export/billing/pdf", payload , {responseType: 'blob'})
            .then(res => {
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                window.open(url)
                this.$store.state.loadingScreen = false
            })
        },
        showPdfBukti(val) {
            this.$store.state.loadingScreen = true
            DataApiUpload.get('load/' + val)
            .then( res => {
                let openWindow = res.config.baseURL + res.config.url
                window.open(openWindow)
                this.$store.state.loadingScreen = false
            })
        },

        /**
         * IMAGE
         */
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            if(parseInt(files[0].size) > 2000000) {
                alert("Maaf, Maksimal Foto 2MB")
            } else {
                this.showImage = files[0];
                this.createImage(files[0]);
            }
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goSave()
                    } else {
                        alert('Upload Photo Failed !')
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goSave()
            } else {
                this.urlPath = this.urlImage
                this.goSave()
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },

        exportXLS() {
            this.$store.state.loadingScreen = true
            let payload = {
                limit: this.totalRow,
                pageIn: 1,
            }
            DataApi.post("billing/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.data
                    var i 
                    for(i=0;i<temp.length;i++) {
                        if(temp[i].status == 'W') {
                            temp[i].status = 'Belum Bayar'
                        } else if(temp[i].status == 'A') {
                            temp[i].status = 'Lunas'
                        } else if(temp[i].status == 'B') {
                            temp[i].status = 'Menunggu Keputusan'
                        }

                        if(temp[i].tipeBilling == 'P') {
                            temp[i].tipeBilling = 'Paket'
                        } else if(temp[i].tipeBilling == 'S') {
                            temp[i].tipeBilling = 'Satuan'
                        }
                    }
                    let data = [
                        {
                            sheet: 'Billing',
                            columns: [
                                { label: 'Nama Perusahaan', value: 'namaPerusahaan'  },
                                { label: 'No Billing', value: 'noBilling' },
                                { label: 'Periode Tagihan', value: 'periode' },
                                { label: 'Tipe Billing', value: 'tipeBilling' },
                                { label: 'Status', value: 'status' },
                                { label: 'Maksimal Pegawai', value: 'maxPegawai'},
                                { label: 'Jumlah Pegawai', value: 'jumlahPegawai'},
                                { label: 'Harga Satuan', value: 'hargaSatuan'},
                                { label: 'Total Harga', value: 'totalHarga'},
                                { label: 'Keterangan', value: 'keteranganApprove'},
                                { label: 'Bukti Bayar(URL)', value: 'buktiBayar'}
                            ],
                            content: temp
                        }
                    ]
                    let settings = {
                        fileName: 'Billing'
                    }
                    xlsx(data, settings)
                } else {
                    alert("Maaf, Terjadi Kesalahan")
                }
                this.$store.state.loadingScreen = false
            })
        },
        getDataFile() {
            this.dataFile = [
                { text: 'Foto/Image', value: '1' },
                { text: 'File Pdf', value: '2' }
            ]
        },
        loadFile(e) {
            let files = document.getElementById('inputFile').files[0]
            this.file = files
            this.fileName = files.name
            this.fileSize = files.size
            if(parseInt(this.fileSize) > 2000000) {
                alert("Maaf, Maksimal lampiran 2MB")
                setTimeout(this.clearFile, 200);
            }
        },
        prosessUpload() {
            if (this.file != '') {
                let imageData = this.file

                const fd = new FormData()
                fd.append('file', imageData)

                DataApiUpload.post('upload', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlFile = response.data.path
                        this.goSave()
                    } else {
                        alert('Upload File Failed !')
                    }
                });
            } else if(this.file == '') {
                this.urlFile = ''
            }
        },
        removeFile() {
            this.file = ''
            this.fileName = ''
            this.fileSize = ''
        },
        clearFile() {
            this.fileName = ''
            this.fileSize = ''
            this.urlFile = ''
            this.file = ''
        },
    },
    mounted() {
        this.getDataToken()
        this.getDataStatus()
        this.getDataFile()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 64px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.cards-image-invalid {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted #e55353 !important;
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 80%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item.is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
</style>
